import { Directive, HostListener, Input } from '@angular/core';
import { Ga4Service } from '../services/ga4/ga4.service';
import { ACC_LOGGEDIN } from '../services/ga4/ga4.constant';

@Directive({
  selector: '[appGaButtonClick]'
})
export class GaButtonClickDirective {
  @Input() buttonLocation: string = '';
  @Input() buttonName: string = '';

  constructor(private ga4Service: Ga4Service) { }

  @HostListener('click', ['$event'])
  onClick(_event: Event): void {
    if (this.buttonLocation && this.buttonName) {
      this.ga4Service.buttonClickEvent(this.buttonLocation, this.buttonName);
    }
  }
}
